import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Item = styled.div`
    width: 28%;
    display: flex;
    flex-flow: row;
    align-items: flex-start;
    margin-bottom: 82px;
    text-align: left;

    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
        margin-bottom: 0;
    }

    @media only screen and (max-width: 1919px) {
        width: 47%;
        margin-bottom: 44px;

        &:nth-child(5),
        &:nth-child(6) {
            margin-bottom: 0;
        }
    }

    @media only screen and (max-width: 1023px) {
        width: 100%;
        margin-bottom: 42px;

        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
            margin-bottom: 42px;
        }
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-bottom: 49px;

        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
            margin-bottom: 49px;
        }
    }
`;

const ServiceIcon = styled.div`
    min-width: 54px;
    height: 54px;
    margin-right: 25px;

    img {
        width: 100%;
        height: 100%;
    }

    @media only screen and (max-width: 767px) {
        min-width: 50px;
        height: 50px;
    }
`;

const ServiceText = styled.div`
    width: 100%;
`;

const ServiceTitle = styled.p`
    font-family: 'robotoLight', sans-serif;
    color: #000;
    margin: 0;
    font-size: 24px;
    line-height: 32px;

    @media only screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 28px;
    }
`;

const ServiceDesc = styled.span`
    font-family: 'robotoLight', sans-serif;
    color: #000;
    margin-top: 11px;
    font-size: 16px;
    line-height: 24px;
    color: #828282;

    @media only screen and (max-width: 767px) {
        margin-top: 0;
    }
`;

export default class ServiceItem extends Component {
    static propTypes = {
        icon: PropTypes.string,
        title: PropTypes.string,
        desc: PropTypes.string,
        price: PropTypes.string,
    };

    render() {
        const { className, icon, title, desc } = this.props;

        return (
            <Item className={className}>
                <ServiceIcon>
                    <img src={icon} alt=''/>
                </ServiceIcon>
                <ServiceText>
                <ServiceTitle>{title}</ServiceTitle>
                <ServiceDesc>{desc}</ServiceDesc>
                </ServiceText>
            </Item>
        );
    }
}
